export const camelCaseToSnakeCase = (value: string) => {
  return value
    .split(/(?=[A-Z])/)
    .join("_")
    .toLowerCase();
};

export default camelCaseToSnakeCase;
